import {
  CONTEXT_PARAMS,
  type AnalyticsEvent,
  type AnalyticsParams,
} from '../events';
import { TrackingDestination } from './TrackingDestination';

const SNAKE_CASE = /^[a-z0-9_]+$/;
const SNAKE_CASE_PARAMS = ['clicked_on', 'section_title'];

/** Tracking for debugging events in the console. */
export class DebugDestination extends TrackingDestination {
  protected isEnabled(): boolean {
    return import.meta.env.VITE_ENVIRONMENT !== 'prod';
  }

  protected send(event: AnalyticsEvent, payload: AnalyticsParams): void {
    // eslint-disable-next-line no-console
    console.debug('[track]', event, payload);

    CONTEXT_PARAMS[event]
      .filter(param => payload[param] == null)
      .forEach(param =>
        // eslint-disable-next-line no-console
        console.warn(`[track] ${event} sin ${param}`, payload),
      );

    SNAKE_CASE_PARAMS.filter(
      param => param in payload && !SNAKE_CASE.test(String(payload[param])),
    ).forEach(param =>
      // eslint-disable-next-line no-console
      console.warn(`[track] ${event}.${param} no está en snake_case`, payload),
    );
  }
}
